import { axios } from 'lib'
import { useQuery } from 'react-query'
import { toast } from 'react-toastify'
import { PaginatedParams } from 'services/api/types'

const loadReferencesByPaymentTerms = (
  params: PaginatedParams
): Promise<{ data: any; total: number }> => {
  const { page = 1, limit = 10 } = params

  return axios.get('/parameters/cond-pag', {
    params: {
      page,
      limit,
      ...params
    }
  })
}

export function useLoadReferencesByPaymentTerms(params: PaginatedParams) {
  return useQuery(
    ['referencePaymentTerms', params],
    () => loadReferencesByPaymentTerms(params),
    {
      keepPreviousData: true,
      onError: () =>
        toast.error(
          'Não foi possível carregar as referências por condição de pagamento!',
          {
            toastId: 'loadReferencePaymentTerms'
          }
        )
    }
  )
}
